import { createFileRoute } from '@tanstack/react-router';
import { Conversation } from '~/features/team-chat/Conversation';

export interface ConversationSearch {
  /** Open the conversation around this message and flash it. */
  seq?: number;
  /** The search pane, open with this query. */
  search?: string;
  /** Only the messages about this task. */
  task?: string;
}

export const Route = createFileRoute('/_app/chat/$id')({
  validateSearch: (s: Record<string, unknown>): ConversationSearch => {
    const seq = Number(s['seq']);
    return {
      seq: Number.isInteger(seq) && seq > 0 ? seq : undefined,
      search: typeof s['search'] === 'string' ? s['search'] : undefined,
      task: typeof s['task'] === 'string' && s['task'] ? s['task'] : undefined,
    };
  },
  component: ConversationRoute,
});

function ConversationRoute() {
  const { id } = Route.useParams();
  const { seq, task, search } = Route.useSearch();
  return <Conversation key={id} id={id} seq={seq} task={task} search={search} />;
}
